const lettersRegulatorsView = r => require.ensure([], () => r(require('@/page/lettersRegulators/lettersRegulatorsView')), 'lettersRegulatorsView');
const lettersInput = r => require.ensure([], () => r(require('@/page/lettersRegulators/lettersInput/lettersInput')), 'lettersInput');
const lettersHandle =r=>require.ensure([],()=>r(require('@/page/lettersRegulators/lettersHandle/lettersHandle')),'lettersHandle');
const lettersTransfer =r=>require.ensure([],()=>r(require('@/page/lettersRegulators/lettersTransfer/lettersTransfer')),'lettersTransfer');
const lettersAddressList =r=>require.ensure([],()=>r(require('@/page/lettersRegulators/lettersAddressList/lettersAddressList')),'lettersAddressList');
const lettersQuery =r=>require.ensure([],()=>r(require('@/page/lettersRegulators/lettersQuery/lettersQuery')),'lettersQuery');

const inspectionAndEvaMgeRouter = {
  path: '',
  component: lettersRegulatorsView,
  meta: { icon: 'inspectionAndEvaMge', right: [],
    isShowMenu: true,
    keepAlive:true,
  },
  name: '信访工作监管',
  children: [
    { path: '/lettersInput', component: lettersInput, name: '信访件录入',
      meta: { right: ['信访件录入'],
        isShowMenu: true,
        keepAlive:true,
      }, },
    { path: '/lettersHandle', component: lettersHandle, name: '信访件办理',
      meta: { right: ['信访件办理'],
        isShowMenu: true,
        keepAlive:true,
      }, },
    { path: '/lettersTransfer', component: lettersTransfer, name: '信访件转办',
      meta: { right: ['信访件办理'],
        isShowMenu: true,
        keepAlive:true,
      }, },
    { path: '/lettersAddressList', component: lettersAddressList, name: '信访工作通讯录',
      meta: { right: ['信访工作通讯录'],
        isShowMenu: true,
        keepAlive:true,
      }, },
    { path: '/lettersQuery', component: lettersQuery, name: '信访件查询',
      meta: { right: ['信访件查询'],
        isShowMenu: true,
        keepAlive:true
      }, }
  ]
};

export default inspectionAndEvaMgeRouter;